"use client";

import type { ComponentProps } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox } from "./Checkbox";

export const CheckboxField = ({
	name,
	...props
}: Omit<ComponentProps<typeof Checkbox>, "isSelected" | "onChange"> & { name: string }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const error = errors[name]?.message as string | undefined;

	return (
		<Controller
			name={name}
			control={control}
			render={({ field }) => (
				<Checkbox
					{...props}
					isSelected={field.value ?? false}
					onChange={field.onChange}
					isInvalid={!!error}
				/>
			)}
		/>
	);
};
